import React from 'react';

interface IHeaderLayoutProps {
  children?: React.ReactNode;
  title: string;
  user?: string;
  helpContent?: any;
}

const NewHomePageLayout: React.FC<IHeaderLayoutProps> = (
  props: IHeaderLayoutProps,
) => {
  const { children } = props;

  return (
    <section
      className='home-content-body Home-HeaderDown'
      style={{ minHeight: 0 }}
    >
      <div className='HomeDashboard-container'>{children}</div>
    </section>
  );
};

export default NewHomePageLayout;
